// Action Types
import axios from 'axios';
import {actionTypes} from '../action-types';
import {serviceConfig} from '../../../config/service-config';
import {addDone, deleteDone} from '../actions/genre-actions';

const handleDeleteAlias = async (dispatch, {aliasId}, id) => {
  const {baseUrl, path, method} = serviceConfig.ALIAS_DELETE;
  const {status} = await axios[method.toLowerCase()](`${baseUrl}${path}/${aliasId}`).catch(() =>
    dispatch(deleteDone({status: null, error: true, id}))
  );
  return dispatch(deleteDone({status, error: status < 200 || status > 300, id}));
};

const handleAddAlias = async (dispatch, {aliasObject}, id) => {
  const {baseUrl, path, method} = serviceConfig.ALIAS_ADD;
  const {aliasName, category, genre} = aliasObject;
  const {status} = await axios[method.toLowerCase()](`${baseUrl}${path}/`, {aliasName, category, genre}).catch(() =>
    dispatch(addDone({status: null, error: true, id}))
  );
  return dispatch(addDone({status, error: status < 200 || status > 300, id}));
};

export const genreMiddleware = store => next => action => {
  const {dispatch} = store;
  const uniqueActionId = Date.now();
  next(action);

  const actions = {
    [actionTypes.ALIAS_ADD]: () => handleAddAlias(dispatch, action.payload, uniqueActionId),
    [actionTypes.ALIAS_DELETE]: () => handleDeleteAlias(dispatch, action.payload, uniqueActionId),
  };

  if (actions[action.type]) {
    return actions[action.type]();
  }
};
